// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3864":"f53267b8","7016":"8691eb9e","8162":"8691eb9e"}[chunkId] + ".chunk.css";
};